
import API from "./api";

// login request
export const loginRequest = (username, password) => {
  return API.post("/login", { username, password });
};